import { v4 as uuidv4 } from "uuid";

/**
 * Extract a plain-text string from a message's content field,
 * which can be a string OR an array of content blocks.
 */
export function getContentString(message) {
  if (!message?.content) return "";
  if (typeof message.content === "string") return message.content;
  if (Array.isArray(message.content)) {
    return message.content
      .filter((b) => b.type === "text")
      .map((b) => b.text)
      .join("");
  }
  return "";
}

/**
 * If the last AI message has tool_calls without matching tool responses,
 * append stub ToolMessages so the API doesn't error out.
 */
export function ensureToolCallsHaveResponses(messages) {
  if (!messages || messages.length === 0) return messages;

  const result = [...messages];
  const last = result[result.length - 1];

  if (last?.type === "ai" && last?.tool_calls?.length) {
    const existingToolMsgIds = new Set(
      result
        .filter((m) => m.type === "tool")
        .map((m) => m.tool_call_id)
    );

    for (const tc of last.tool_calls) {
      if (!existingToolMsgIds.has(tc.id)) {
        result.push({
          type: "tool",
          name: tc.name,
          tool_call_id: tc.id,
          content: "Interrupted — no response received.",
          id: uuidv4(),
        });
      }
    }
  }

  return result;
}

/** Prefix used by LangGraph for messages that shouldn't be rendered */
export const DO_NOT_RENDER_PREFIX = "do-not-render-";

/** Check whether a message should be rendered in the UI */
export function shouldRenderMessage(message) {
  if (!message?.id) return true;
  return !message.id.startsWith(DO_NOT_RENDER_PREFIX);
}
